import {mock} from './index';

export default {
  getSubAdminList: () => mock('/admin/subadmin/list'),
  removeSubAdmin: () => mock('/admin/subadmin/remove'),
  getSubAdmin: () => mock('/admin/subadmin/get'),
  getSubAdminStructureList: () => mock('/admin/subadmin/structure/list'),
  getSubAdminRoleList: () => mock('/admin/subadmin/role/list'),
  getSubAdminCreateUserList: () => mock('/admin/subadmin/create/user/list'),
  createOrModifySubAdmin: () => mock('/admin/subadmin/createOrModify'),
  getSubAdminStructureChildren: () => mock('/admin/subadmin/structure/getChildren'),
  getStructureManageList: () => mock('/admin/subadmin/structure/manageList'),
  getSubAdminAllStructureList: () => mock('/admin/structure/getCompleteStructure'),
  getOperationList: () => mock('/admin/operation/list'),
  getUserGroupList: () => mock('/admin/subadmin/userGroup/list')
};
